import Vue from 'vue';
import { assign, findIndex, each } from 'lodash';
import * as api from 'api/api-stuff-to-eat';
import * as types from '../mutation-types';

function removeArrayItemsByID(array, images) {
  each(images, (id) => {
    const index = findIndex(array, o => o.id === id);
    array.splice(index, 1);
  });
}

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  error: null,
  notFound: null,
  empty: false,
  meta: {},
  data: [],
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  empty: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = {};

const getters = {
  StuffToEatImages: state => id => state[id],
};

const actions = {
  GetStuffToEatImages({ commit }, params) {
    const id = params.id;
    const type = params.type;

    commit(types.FETCH_STUFF_TO_EAT_IMAGES_START, { id });
    api.getImages(
      type,
      id,
      (response) => {
        commit(types.RECEIVE_STUFF_TO_EAT_IMAGES, { id, response });
      },
      (description, status, error) => {
        commit(types.FETCH_STUFF_TO_EAT_IMAGES_ERROR, { id, error });
      },
    );
  },
  UploadStuffToEatImage({ dispatch, commit }, params) {
    console.log('UploadStruffToEatImage', params);
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const images = params.images;

      commit(types.UPLOAD_STUFF_TO_EAT_IMAGE_START, { id });
      api.uploadImages(
        type,
        id,
        images,
        (response) => {
          commit(types.UPLOAD_STUFF_TO_EAT_IMAGE_SUCCESSFUL, { id, response });
          dispatch('SetStuffToEatMainImage', { id, images: response.data });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.UPLOAD_STUFF_TO_EAT_IMAGE_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  RemoveStuffToEatImages({ commit }, params) {
    console.log('RemoveStuffToEatImages', params);
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const payload = params.payload;

      commit(types.REMOVE_STUFF_TO_EAT_IMAGES_START, { id });
      api.removeImages(
        type,
        id,
        payload,
        () => {
          commit(types.REMOVE_STUFF_TO_EAT_IMAGES_SUCCESSFUL, { id, images: payload.images });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.REMOVE_STUFF_TO_EAT_IMAGES_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  UpdateStuffToEatImages({ dispatch, commit }, params) {
    console.log('UpdateStuffToEatImages', params);
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const payload = params.payload;

      commit(types.UPDATE_STUFF_TO_EAT_IMAGES_START, { id });
      api.updateImages(
        type,
        id,
        payload,
        (response) => {
          commit(types.UPDATE_STUFF_TO_EAT_IMAGES_SUCCESSFUL, { id, response });
          dispatch('SetStuffToEatMainImage', { id, images: response.data });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.UPDATE_STUFF_TO_EAT_IMAGES_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  ClearStuffToEatImages({ commit }, { id }) {
    commit(types.CLEAR_STUFF_TO_EAT_IMAGES, { id });
  },
};

const mutations = {
  [types.FETCH_STUFF_TO_EAT_IMAGES_START](state, { id }) {
    console.log('FETCH_STUFF_TO_EAT_IMAGES_START');
    if (state[id]) Vue.set(state, id, assign(state[id], neutralState, { fetching: true }));
    else Vue.set(state, id, assign({}, initState, { fetching: true }));
  },
  [types.FETCH_STUFF_TO_EAT_IMAGES_ERROR](state, { id, error }) {
    console.log('FETCH_STUFF_TO_EAT_IMAGES_ERROR');
    Vue.set(state, id, assign(state[id], neutralState, { error }));
  },
  [types.RECEIVE_STUFF_TO_EAT_IMAGES](state, { id, response }) {
    console.log('RECEIVE_STUFF_TO_EAT_IMAGES', response);
    const empty = response.data.length === 0;
    Vue.set(state, id, assign(state[id], neutralState, { ready: true, meta: response.meta, data: response.data, empty }));
  },

  [types.CLEAR_STUFF_TO_EAT_IMAGES](state, { id }) {
    console.log('CLEAR_STUFF_TO_EAT_IMAGES');
    Vue.delete(state, id);
  },

  [types.UPLOAD_STUFF_TO_EAT_IMAGE_START](state, { id }) {
    console.log('UPLOAD_STUFF_TO_EAT_IMAGE_START');
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.UPLOAD_STUFF_TO_EAT_IMAGE_SUCCESSFUL](state, { id, response }) {
    console.log('UPLOAD_STUFF_TO_EAT_IMAGE_SUCCESSFUL', response);
    Vue.set(state, id, assign(state[id], neutralState));
    each(response.data, (image) => {
      state[id].data.push(image);
    });
  },
  [types.UPLOAD_STUFF_TO_EAT_IMAGE_ERROR](state, { id, saveError }) {
    console.log('UPLOAD_STUFF_TO_EAT_IMAGE_ERROR');
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },

  [types.REMOVE_STUFF_TO_EAT_IMAGES_START](state, { id }) {
    console.log('REMOVE_STUFF_TO_EAT_IMAGES_START');
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.REMOVE_STUFF_TO_EAT_IMAGES_SUCCESSFUL](state, { id, images }) {
    console.log('REMOVE_STUFF_TO_EAT_IMAGES_SUCCESSFUL', images);
    removeArrayItemsByID(state.data, images);
    const empty = state[id].data.length === 0;
    Vue.set(state, id, assign(state[id], neutralState, { empty }));
  },
  [types.REMOVE_STUFF_TO_EAT_IMAGES_ERROR](state, { id, saveError }) {
    console.log('REMOVE_STUFF_TO_EAT_IMAGES_ERROR');
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },

  [types.UPDATE_STUFF_TO_EAT_IMAGES_START](state, { id }) {
    console.log('UPDATE_STUFF_TO_EAT_IMAGES_START');
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.UPDATE_STUFF_TO_EAT_IMAGES_SUCCESSFUL](state, { id, response }) {
    console.log('UPDATE_STUFF_TO_EAT_IMAGES_SUCCESSFUL', response);
    Vue.set(state, id, assign(state[id], neutralState, { update: true, data: response.data }));
  },
  [types.UPDATE_STUFF_TO_EAT_IMAGES_ERROR](state, { id, saveError }) {
    console.log('UPDATE_STUFF_TO_EAT_IMAGES_ERROR');
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/stuff-to-eat/entities/stuff-to-eat-images.js